import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

interface Props {
  /** TableHead and TableBody elements */
  children: React.ReactNode;
  /** optional prop if table contents are being loaded from elsewhere */
  loading?: boolean;
  /** loaded table data */
  results?: Array<any>;
  /** className for extra styles */
  className?: string;
}

const useStyles = makeStyles({
  table: {
    width: '100%',
    textAlign: 'left',
    borderCollapse: 'collapse'
  },
  loading: {
    opacity: '0.7',
    pointerEvents: 'none'
  }
});

/**
 * Table with optional sorting,
 */
const Table = ({ children, loading, results, className }: Props) => {
  const classes = useStyles();
  return (
    <table
      className={clsx(
        loading && results && results.length > 0 && classes.loading,
        classes.table,
        className
      )}
    >
      {children}
    </table>
  );
};

export default Table;
